/* Firebase Constants */
export const USER_COLLECTION = "users";
export const SESSION_COLLECTION = "session";
export const SESSION_GAME_DOC_ID = "currentGame";
export const DISPLAY_NAME_COLLECTION = "displayNames";
export const USERNAME_MAX_LENGTH = 30;

/* API Constants */
export const DETAILED_WIKIPEDIA_API_BASE =
  "https://en.wikipedia.org/w/rest.php/v1";
export const WIKIPEDIA_API_BASE = "https://en.wikipedia.org/api/rest_v1";
